import { loadScript, loadCSS } from 'utils/index';
import { processEnv } from 'utils/config';

const h5_fe_lib =
  processEnv.hostEnv == 'online'
    ? '//h5cdn.babytreeimg.com'
    : '//h5cdn-1.babytree-test.com';

export function lazyWTA() {
  if (window.WTA) {
    return Promise.resolve(window.WTA);
  } else {
    return loadScript(`${h5_fe_lib}/h5_fe_lib/release/w2a/1.4.1/index.min.js`, {
      attrs: { crossorigin: 'anonymous' }
    }).then(() => {
      return window.WTA;
    });
  }
}

export function lazyWLA() {
  if (window.WLA) {
    return Promise.resolve(window.WLA);
  } else {
    return loadScript(`${h5_fe_lib}/h5_fe_lib/release/wla/0.0.17/index.min.js`, {
      attrs: { crossorigin: 'anonymous' }
    }).then(() => {
      return window.WLA;
    });
  }
}

export function lazyMonitor() {
  if (window.bbtMonitor) {
    return Promise.resolve(window.bbtMonitor);
  } else {
    return loadScript(
      `${h5_fe_lib}/h5_fe_lib/release/monitor/2.0.6/index.min.js?data=20230324`,
      {
        attrs: { crossorigin: 'anonymous' }
      }
    ).then(() => {
      return window.bbtMonitor;
    });
  }
}

export function lazySwiper() {
  if (window.Swiper) {
    return Promise.resolve(window.Swiper);
  } else {
    return loadScript(`${h5_fe_lib}/h5_fe_lib/libs/swiper.min.js`, {
      attrs: { crossorigin: 'anonymous' }
    }).then(() => {
      return window.Swiper;
    });
  }
}

export function lazyBBTVideoPlayer() {
  if (window.bbtVideoPlayer) {
    return Promise.resolve(window.bbtVideoPlayer);
  } else {
    loadCSS(
      `${h5_fe_lib}/h5_fe_lib/release/bbt-video-player/0.0.1/index.min.css`
    );
    return loadScript(
      `${h5_fe_lib}/h5_fe_lib/release/bbt-video-player/0.0.1/index.js`,
      {
        attrs: { crossorigin: 'anonymous' }
      }
    ).then(() => {
      return window.bbtVideoPlayer;
    });
  }
}


export function lazyWeixinJsSdk() {
  if (window.wx) {
    return Promise.resolve(window.wx);
  } 
  return loadScript(`//res.wx.qq.com/open/js/jweixin-1.6.0.js`, {
  }).then(() => {
    return window.wx;
  });
  
}